export interface IControlButtonsAndDots {
  classBoundaryButtons?: string;
  currentPage: number;
  totalPages: number;
  handlePrev: () => void;
  jumpto: (index: number) => void;
  handleNext: () => void;
}

export const ControlButtonsAndDots = ({
  currentPage,
  totalPages,
  handlePrev,
  jumpto,
  handleNext,
  classBoundaryButtons,
}: IControlButtonsAndDots) => {
  const boundClass = classBoundaryButtons ?? 'w-12 h-12';

  return (
    <div className="flex items-center justify-center mt-auto space-x-4 mb-4">
      {/* Left Arrow Button */}
      <button
        onClick={handlePrev}
        disabled={currentPage === 0}
        className={`flex items-center justify-center ${boundClass} rounded-full bg-red-600 text-white disabled:opacity-50 disabled:cursor-not-allowed`}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="h-6 w-6"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          strokeWidth={2}
        >
          <path strokeLinecap="round" strokeLinejoin="round" d="M15 19l-7-7 7-7" />
        </svg>
      </button>

      {/* Pagination Dots */}
      <div className="flex gap-5">
        {totalPages > 1 &&
          Array.from({ length: totalPages }).map((_, index) => (
            <div
              key={index}
              className={`w-4 h-4 rounded-full transition-scale duration-500 ${
                index === currentPage ? 'bg-gray-700 scale-[1.5]' : 'bg-gray-300'
              } cursor-pointer`}
              onClick={() => {
                jumpto(index);
              }}
            ></div>
          ))}
      </div>

      {/* Right Arrow Button */}
      <button
        onClick={handleNext}
        disabled={currentPage === totalPages - 1}
        className={`flex items-center justify-center ${boundClass} rounded-full bg-red-600 text-white disabled:opacity-50 disabled:cursor-not-allowed`}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="h-6 w-6"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          strokeWidth={2}
        >
          <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />
        </svg>
      </button>
    </div>
  );
};
